import { useState } from "react";
import { db } from "../firebase";
import { addDoc, collection } from "firebase/firestore";

function Registration() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    ministry: "",
    church: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "registrations"), {
        ...form,
        createdAt: new Date()
      });

      alert("Registration submitted successfully!");

      setForm({
        name: "",
        email: "",
        phone: "",
        ministry: "",
        church: ""
      });
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
  };

  const inputStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    outline: "none",
    fontSize: "14px"
  };

  return (
    <section
      id="registration"
      style={{
        padding: "90px 20px",
        background: "#f5f5f5",
        textAlign: "center"
      }}
    >
      <h2 style={{ fontSize: "34px", marginBottom: "10px" }}>
        Registration
      </h2>

      <p style={{ color: "#666", marginBottom: "30px" }}>
        Join us for Worshippers Unite. Please fill in your details below.
      </p>

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: "450px",
          margin: "0 auto",
          background: "white",
          padding: "25px",
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          gap: "15px"
        }}
      >
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={form.email}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          value={form.phone}
          onChange={handleChange}
          required
          style={inputStyle}
        />

        <input
          type="text"
          name="ministry"
          placeholder="Ministry You Serve In"
          value={form.ministry}
          onChange={handleChange}
          style={inputStyle}
        />

        <input
          type="text"
          name="church"
          placeholder="Church / Organization Attended"
          value={form.church}
          onChange={handleChange}
          style={inputStyle}
        />

        <button
          type="submit"
          style={{
            padding: "14px",
            background: "#000",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "15px",
            cursor: "pointer",
            marginTop: "10px"
          }}
        >
          Submit Registration
        </button>
      </form>
    </section>
  );
}

export default Registration;